/**
 * Miniaturní DOM helpery — žádný framework, plná kontrola.
 */

type Attrs = Record<string, string | number | boolean | EventListener | undefined>;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  ...children: Array<Node | string | null | undefined | false>
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) continue;
    if (key.startsWith('on') && typeof value === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), value as EventListener);
    } else if (key === 'className') {
      node.className = String(value);
    } else if (key === 'value' && (node instanceof HTMLInputElement || node instanceof HTMLSelectElement || node instanceof HTMLTextAreaElement)) {
      node.value = String(value);
    } else if (key === 'checked' && node instanceof HTMLInputElement) {
      node.checked = value === true || value === 'true';
    } else if (value === true) {
      node.setAttribute(key, '');
    } else {
      node.setAttribute(key, String(value));
    }
  }
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    node.append(child instanceof Node ? child : document.createTextNode(child));
  }
  return node;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

export function fragment(...children: Array<Node | string | null | undefined | false>): DocumentFragment {
  const f = document.createDocumentFragment();
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    f.append(child instanceof Node ? child : document.createTextNode(child));
  }
  return f;
}

/** Debounce s návratem rušitelné funkce. */
export function debounce<A extends unknown[]>(fn: (...args: A) => void, ms: number): (...args: A) => void {
  let t: number | undefined;
  return (...args: A) => {
    if (t !== undefined) window.clearTimeout(t);
    t = window.setTimeout(() => fn(...args), ms);
  };
}

/** Formátování čísel v češtině. */
export const fmtKm = (km: number): string =>
  km >= 10 ? `${km.toFixed(0)} km` : km >= 1 ? `${km.toFixed(1)} km` : `${Math.round(km * 1000)} m`;

export const fmtCzk = (czk: number): string =>
  czk < 0.5 ? 'zdarma' : `${Math.round(czk)} Kč`;

export const fmtCo2 = (g: number): string =>
  g < 1 ? '0 g' : g >= 1000 ? `${(g / 1000).toFixed(1)} kg` : `${Math.round(g)} g`;

export const fmtComfort = (c: number): string => `${'★'.repeat(Math.round(c))}${'☆'.repeat(Math.max(0, 5 - Math.round(c)))}`;
